export const CHAT_LIVE_API = 'https://go.arena.im/embed/chat';
